import { render, staticRenderFns } from "./WebPageHeader.vue?vue&type=template&id=2a0f84cf&scoped=true"
import script from "./WebPageHeader.vue?vue&type=script&lang=js"
export * from "./WebPageHeader.vue?vue&type=script&lang=js"
import style0 from "./WebPageHeader.vue?vue&type=style&index=0&id=2a0f84cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f84cf",
  null
  
)

export default component.exports